import ensureEnv from "@treefort/lib/ensure-env";
export const config = Object.assign(Object.assign({}, ensureEnv({
    ENV: "production",
})), { PROXY_ORIGIN: "https://epub.treefortsystems.com" });
